// Dependencies
import { Portal } from "react-portal";
import { CSSTransition } from "react-transition-group";

// Types
import { Components } from '../types';

const Overlay = ({isVisible, height, isPortaled = false, onClick: handleClick = undefined, className = []}: Components.Overlay) => {

	const overlay = (
		<div style={{height: `${height}px`}} onClick={(e) => handleClick && handleClick(e)} className={['wooptima-overlay', ...className].join(' ')}></div>
	);

	if ( isPortaled ) {
		return (
			<CSSTransition mountOnEnter unmountOnExit in={isVisible} timeout={500}>
				<Portal>{overlay}</Portal>
			</CSSTransition>
		)
	}

	return (
		<CSSTransition mountOnEnter unmountOnExit in={isVisible} timeout={500}>
			{overlay}
		</CSSTransition>
	)
}

export default Overlay;
